<div class="card">
  <div class="card-body">
    <spk-search-grid [list]="'SearchGridFormatTestSearchRow'" title="Searches" autoload="true" defaultSortProperty="" showSearch="true" [cellLinks]="cellLinks"></spk-search-grid>
  </div>
</div>